export default "__VITE_ASSET__B3OW3NyB__"